class Visual {
	constructor(config) {
		this.config = Object.assign({
			scope: '.visual'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.#updatePseudoTop();
		this.#bindEvents();
	}

	#updatePseudoTop() {
		if ($(window).width() < 768) {
			const col = this.$scope.find('.after-height')[0];
			const scope = this.$scope[0];

			let offset = col.offsetTop;
			let el = col.offsetParent;

			while (el && el !== scope) {
				offset += el.offsetTop;
				el = el.offsetParent;
			}

			this.$scope[0].style.setProperty('--pseudo-top', `${offset}px`);
			this.$scope.closest('.section-type-visual')[0]
				?.style.setProperty('--pseudo-top', `${offset}px`);
		} else {
			this.$scope[0].style.removeProperty('--pseudo-top');
			this.$scope.closest('.section-type-visual')[0]
				?.style.removeProperty('--pseudo-top');
		}
	}

	#bindEvents() {
		$(window).on('resize', () => this.#updatePseudoTop());
	}
}

export default new Visual;